export enum UserPreference {
  ONBOARDING_DISABLED = "general-onboarding-disabled",
  QR_CODE_ONBOARDING_DISABLED = "qr-code-onboarding-disabled",
  COACH_ME_NUDGE_ALERT_VIEWED = "coach-me-nudge-alert-viewed",
  // deprecated values
  // HAS_CLICKED_DOWNLOAD_APPS = "has-clicked-download-apps",
}

export enum UserBookPreference {
  COACH_ME_ONBOARDING_DISABLED = "coach-me-onboarding-disabled",
  COACH_ME_TAG_DISABLED = "coach-me-tag-disabled",
  ERESOURCES_TOAST_DISABLED = "eresources-toast-disabled",
  COACH_ME_PREFS_ALERT_VIEWED = "coach-me-prefs-alert-viewed",
  COACH_ME_PUBLISHER_DEACTIVATED_ALERT_VIEWED = "coach-me-publisher-deactivated-alert-viewed",
  COACH_ME_DISABLED = "coach-me-disabled",
  COACH_ME_NUDGES_DISABLED = "coach-me-nudges-disabled",
  COACH_ME_TOASTS_DISABLED = "coach-me-toasts-disabled",
}

export interface PreferencesItem<T = unknown> {
  updatedAt: string;
  version: number;
  value: T;
}

export function isValidPreferenceItem(pref: any): pref is PreferencesItem {
  return (
    typeof pref === "object" &&
    pref !== null &&
    !Array.isArray(pref) &&
    Object.keys(pref).length === 3 &&
    typeof pref.updatedAt === "string" &&
    typeof pref.version === "number" &&
    Object.keys(pref).indexOf("value") !== -1
  );
}

export function getPreferenceItem(value): PreferencesItem {
  return {
    value,
    version: 0,
    updatedAt: new Date().toUTCString(),
  };
}
